export default {"src":"/_next/static/media/logo-resale.ff444d65.svg","height":79,"width":233};